type PropertyName = 'font-size' | 'font-family'

export const applySelectedFormatToElement = (
  editor: Editor,
  querySelector: string,
  propertyCommand: 'FontSize' | 'FontName',
  propertyName: PropertyName,
) => {
  if (!editor || !querySelector) return
  const propertyValue = editor.queryCommandValue(propertyCommand)
  if (!propertyValue) return

  const editorBody = editor.getBody()

  try {
    if (!editorBody) return

    const targetElement = editorBody.querySelector(
      querySelector,
    ) as HTMLElement | null

    if (!targetElement) return

    targetElement.setAttribute(`data-persistent-${propertyName}`, propertyValue)
    updateStyle(targetElement, 'style', propertyValue, propertyName)
    updateStyle(targetElement, 'data-style', propertyValue, propertyName)
    updateStyle(targetElement, 'data-mce-style', propertyValue, propertyName)
  } catch (error) {
    console.error(`Error applying ${propertyName} to element`, error)
  }
}

const updateStyle = (
  targetElement: HTMLElement,
  attribute: string,
  propertyValue: string,
  propertyName: PropertyName,
) => {
  if (!attribute) return
  const currentElementStyle = targetElement.getAttribute(attribute) || ''
  const updatedElementStyle = updatePropertyStyleAttribute(
    currentElementStyle,
    propertyValue,
    propertyName,
  )
  targetElement.setAttribute(attribute, updatedElementStyle)
}

const updatePropertyStyleAttribute = (
  styleString: string,
  propertyValue: string,
  propertyName: PropertyName,
) => {
  const styles = styleString
    .split(';')
    .map((s) => s.trim())
    .filter((s) => s.length > 0 && !s.startsWith(propertyName))

  styles.push(`${propertyName}: ${propertyValue}`)
  return styles.join('; ')
}
